export default "__VITE_ASSET__B5qm6ofg__"